import { render } from "./ShippingGatewayComponent.vue?vue&type=template&id=77a790de"
import script from "./ShippingGatewayComponent.vue?vue&type=script&lang=js"
export * from "./ShippingGatewayComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ShippingGateway/ShippingGatewayComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77a790de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77a790de', __exports__)) {
    api.reload('77a790de', __exports__)
  }
  
  module.hot.accept("./ShippingGatewayComponent.vue?vue&type=template&id=77a790de", () => {
    api.rerender('77a790de', render)
  })

}


export default __exports__